import { useState, useEffect } from 'react';
import Axios from "axios";
import { GenerateContent, GetCandidatesByJobTitle, search } from '../apiconstants/constants.js';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner.js';
import ConsultantLayout from '../commonlayouts/consultantlayout.js';
import * as pdfjsLib from "pdfjs-dist";
import stringSimilarity from "string-similarity";
import Mammoth from "mammoth";
import Swal from 'sweetalert2';
import { Modal, Button, Form } from "react-bootstrap";
import axios from 'axios';
import { useCountry } from '../contexts/countrycodecontext.js';
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const plainText = doc.body.textContent || "";
  return plainText;
};
const safeValue = (value) => 
  (value === null || value === undefined || value === "null" || value === "undefined") 
    ? "" 
    : value;
function substring_str(str) {
  if ((str === null) || (str === ' ' || str === undefined))
    return "";
  else
    str = str.toString();
  return str.substring(0, 20) + "...";
}
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ViewAppliedCandidatesforJob = () => {
    let query = useQuery();
    const jobPostID = query.get("jobpost");
  const location = useLocation();
  const navigate = useNavigate();
  const jobDescription = location.state?.jobDescription ? location.state?.jobDescription : localStorage.getItem('jobDescription') 
   const jobPlainText = stripHtml(jobDescription).toLowerCase() ;
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState([]);
  const [perPage] = useState(25);
  const [pageCount, setPageCount] = useState(0);
  const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [startDate, setStartDate] = useState(""); // Start date state
  const [endDate, setEndDate] = useState(""); // End date state
  const [showIcon, setShowIcon] = useState('list');
  const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
  const token = localStorage.getItem('jwtToken');
   const [selectedCards, setSelectedCards] = useState(
     JSON.parse(localStorage.getItem('selectedCandidates')) || []
   );
       let Guid="";
  const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const roleID = localStorage.getItem("roleID")
    
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= userguid
    }
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };
  const handleViewToggle = (type) => {
    setViewType(type);
    setShowIcon(type)
  };


  useEffect(() => {
    fetchCandidates();
  }, [jobPlainText]);

const fetchCandidates = async () => {
  try {
      const payload ={
  "userGuid": Guid,
  "jobTitleID": jobPostID
}
   const res = await Axios.post(GetCandidatesByJobTitle.APIURL, payload,
    { headers: { Authorization: `Bearer ${token}` } }
   ); // replace with actual API
    if (res.data && Array.isArray(res.data)) {
      setCandidateData(res.data); // assuming this holds final display candidates
    }
  } catch (err) {
    console.error("Error fetching LinkedIn candidates", err);
  }
};



  const getUniqueId = (card) => card.email || card.linkedInUrl || card.name;

  const handleCardClick = (clickedCard) => {
  const clickedCardID = getUniqueId(clickedCard);

  setSelectedCards((prevSelectedCards) => {
    const isCardSelected = prevSelectedCards.some((card) => getUniqueId(card) === clickedCardID);
    let updatedSelectedCards;

    if (isCardSelected) {
      updatedSelectedCards = prevSelectedCards.filter((card) => getUniqueId(card) !== clickedCardID);
    } else {
      updatedSelectedCards = [...prevSelectedCards, clickedCard];
    }

    return updatedSelectedCards;
  });
};

const handleViewCandidate = (candidateID) => {
  navigate(`/Employer/ViewAppliedCandidatesforJob/ViewAppliedCandidateDetailsbyId?id=${candidateID}&jobpost=${jobPostID}`);
};

  useEffect(() => {
    

    const slice = candidateData.slice(offset, offset + perPage);
    const items = viewType == 'grid' ? slice.map((data) => {
const isChecked = selectedCards.some(item => getUniqueId(item) === getUniqueId(data));

      return (
        <div className="col-sm-12 col-md-4 col-xl-4 col-lg-4 pb-3" key={data.guid}>
          <div className="card mt-2" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 400, height: 400, borderRadius: 20 }}>
            <div className='card-header' style={{ background: "none", minHeight: 140 }}>
              <div className='row'>
                <div className='col-8'>
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>
                        <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.fullName}</b></p>
                      </OverlayTrigger>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Role</Tooltip>)}>
                        <h5 style={{ fontSize: 18 }}>{data.jobRoleName}</h5>
                      </OverlayTrigger>
                </div>
              </div>
            </div>
            <div className="card-body" style={{ minHeight: 180 }}>
                     <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.technicalSkill}</Tooltip>)}>
                    <p style={{ fontSize: 14, textAlign: 'justify' }}>
                      <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-code" aria-hidden="true"></i>
                      {substring_str(data.technicalSkill)}
                    </p>
                  </OverlayTrigger>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-phone" aria-hidden="true"></i> {data.mobileNumber} </p>
                  </OverlayTrigger>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-envelope" aria-hidden="true"></i> {data.email}</p>
                  </OverlayTrigger>  
                   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Client Status</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user" aria-hidden="true"></i> {data.clientStatus}</p>
                  </OverlayTrigger>
          
            </div>
                 <div   className={`card-footer d-flex justify-content-center`} style={{ background: "none" }} >

              <OverlayTrigger
                        placement="bottom"
                        overlay={(props) => (
                          <Tooltip id="tooltip" {...props}>
                            View Candidate
                          </Tooltip>
                        )}
                      >
                        <button
                    onClick={() => handleViewCandidate(data.guid)}
                          style={{ background: "none", border: "none", padding: "4px" }}
                        >
                          <i
                            className="fa fa-eye"
                            aria-hidden="true"
                            style={{ fontSize: 16, color: "#00a7ac" }}
                          ></i>
                        </button>
                      </OverlayTrigger>
                      </div>           
          </div>
        </div>
      );
    }) :

      <div className="col-12 mt-2" style={{ overflowX: "auto", width: "100%" }}>
        <table className="table" style={{ minWidth: "100%", fontSize: 14 }}>
          <thead>
            <tr>
              <th>Full Name</th>
              <th>Job Role</th>
             <th>Technical Skill</th>
              <th>Email</th>
              <th>Mobile Number</th>
               <th>Client Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {slice?.map((data, index) => {
         const isChecked = selectedCards.some(item => getUniqueId(item) === getUniqueId(data));
              console.log("isChekd", isChecked)
              return (
                <tr key={index}>
                  <td style={{ padding: "4px" }}>{safeValue(data.fullName)}</td>
                 <td style={{ padding: "4px" }}>{safeValue(data.jobRoleName)}</td>
               <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
             {safeValue(data.technicalSkill)}
            </Tooltip>
          )}
        >
          <td style={{ padding: "4px" }}>{safeValue(substring_str(data.technicalSkill))}</td>
        </OverlayTrigger>
         <td style={{ padding: "4px"}}>{safeValue(data.email)}</td>
        <td style={{ padding: "4px" }}>{safeValue(data.mobileNumber)}</td>
        <td style={{ padding: "4px"}}>{safeValue(data.clientStatus)}</td>
        <td>
           <OverlayTrigger
                        placement="bottom"
                        overlay={(props) => (
                          <Tooltip id="tooltip" {...props}>
                            View Candidate
                          </Tooltip>
                        )}
                      >
                        <button
                  onClick={() => handleViewCandidate(data.guid)}
                          style={{ background: "none", border: "none" }}
                        >
                          <i
                            className="fa fa-eye"
                            aria-hidden="true"
                            style={{ fontSize: 16, color: "#00a7ac",borderBottomWidth:0 }}
                          ></i>
                        </button>
                      </OverlayTrigger>
        </td>
                </tr>

              )
            })}
          </tbody>
        </table>
      </div>

    setData(items);
    setPageCount(Math.ceil(candidateData.length / perPage));
  }, [offset, searchTerm, startDate, endDate, candidateData, perPage, viewType, selectedCards]);

  return (
    <ConsultantLayout>
      <div className='container-fluid mt-3'>
 <div class="responsive-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link to="/Employer/ListOfJobPosts">
              <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8 }} aria-hidden="true"></i>
            </Link>
            <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>View Applied Candidates</h2>
          </div>
          {showIcon === 'grid' && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
              <button
                className="btn btn-primary"
                onClick={() => handleViewToggle('list')}
                style={{ backgroundColor: "#00a7ac" }}
              >
                <i className="fa fa-th-list" style={{ color: '#fff', cursor: 'pointer' }}></i>
              </button>
            </OverlayTrigger>
          )}
          {showIcon === 'list' && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
              <button
                className="btn btn-primary"
                onClick={() => handleViewToggle('grid')}
                style={{ backgroundColor: "#00a7ac" }}
              >
                <i className="fa fa-th" style={{ color: '#fff', cursor: 'pointer' }}></i>
              </button>
            </OverlayTrigger>
          )}

                      {/* {selectedCards.length > 0 && selectedCards.some(item => item.email) && (
  <div style={{ textAlign: 'right', marginTop: '10px' }}>
    <button className="btn btn-primary" onClick={handleForwardClick}>
      <i className="fa fa-arrow-right"></i> Send Email
    </button>
  </div>
)} */}
        </div>
        <div>

        </div>

        <hr />

        <div className="row mt-3 pb-3">
                   {isLoading ? <center><LoadingSpinner /></center> : <>
            <div>

            </div>

            {data}
          </>}
        </div>
        {candidateData.length === 0 && (
          <div className="pb-5 text-center">
            <img title='No Data' className='no-data-img' src={nodataimg} style={{ height: 350 }} />
          </div>
        )}

        {(candidateData.length === 0) || (data?.length === 0) && (
          <div className="pb-5 text-center">
            <img title='No Data' className='no-data-img' src={nodataimg} style={{ height: 350 }} />
          </div>
        )}

              {
          candidateData.length > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }


      </div>
    </ConsultantLayout>
  );
}

export default ViewAppliedCandidatesforJob;


